/*
 Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { TFunction } from 'next-i18next';
import * as yup from 'yup';

import { getLoginDefaultValues } from './login-form.utils';

export const loginSchema = (isManager: boolean, t: TFunction) => {
  const { password, type, username } = getLoginDefaultValues(isManager);

  return yup.object().shape({
    type: yup.string().required().default(type),
    username: yup
      .string()
      .min(1, t('ERROR_NOMBRE_MINIMO_CARACTERES', { count: 1 }))
      .max(10, t('ERROR_NOMBRE_MAXIMO_CARACTERES', { count: 10 }))
      .required(t('ERROR_CAMPO_OBLIGATORIO'))
      .default(username),
    password: yup.string().required(t('ERROR_CAMPO_OBLIGATORIO')).default(password),
  });
};
